module.exports = __webpack_public_path__ + "media/images/front/icon_blank_01-06b98d6f9991ccc5f0e699888d887f9d.svg";